import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  mealItemContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    mb: theme.spacing(2),
    p: 0,
  },
  mealClickArea: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    flex: 1,
    cursor: 'pointer',
  },
  imageContainer: {
    width: 60,
    height: 60,
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover' as const,
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: theme.spacing(1),
  },
  imagePlaceholder: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.grey[200],
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: theme.spacing(1),
  },
  mealInfo: {
    flex: 1,
  },
  variantText: {
    color: 'text.secondary',
  },
});
